import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Service from './chanage-password.service'
import './change-password.styles.scss'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import Form from './form.component'
import FormHelper from '../../../utils/FormHelper'

class ChangePassword extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.service.isValid() && this.service.changePassword()
    }

    onCancel = () => this.props.history.push('/settings')

    render() {
        return (
            <>
                {this.state.updating && <Dialog><Loading></Loading></Dialog>}
                <div className="change-password">
                    <div className="section-header">
                        <h4>Change Password</h4>
                    </div>
                    <div className="card">
                        <div className={"flag " + this.state.flag.type}>
                            {this.state.flag.text}
                        </div>
                        <Form {...this.state} onChange={FormHelper(this, "changePassword").onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}/>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(ChangePassword))